import { typeLogins } from '@/config'

var login = {
	namespaced: true,
	state: {
		email: '',
		token: '',
		refresh: ''
	},
	getters: {
		isAuth(state) {
      if (state.token) { return true }
      return false
		},
		getLoginUserEmail(state) {
			return state.email
		},
		getLoginUserToken(state) {
			return state.token
		}
	},
	mutations: {
		loginTokens(state, payload) {
			state.email = payload.email
			state.token = payload.idToken
		},
		authFailed(state, payload) {
			if (payload === "reset") {
        state.authFailed = false
      } else {
        state.authFailed = true
      }
		},
		logoutUser(state) {
			state.email = null
      state.token = null
      localStorage.removeItem('token')
    }
	},
	actions: {
		loginSimple({commit}, payload) {
			if (payload.email && payload.password) {
				if (payload.email == typeLogins.data.email && payload.password == typeLogins.data.password) {
					var nUser = {
						email: payload.email,
						idToken: btoa(payload.password)
					}
					commit('loginTokens', nUser)
					localStorage.setItem('token', btoa(JSON.stringify(nUser)))
					commit('setLoading', false, {root: true})
				}
			}
		},
		getLoginSimple({commit}) {
			if (localStorage.getItem('token')) {
				var tokenA = JSON.parse(atob(localStorage.getItem('token')))
				if (tokenA.email == typeLogins.data.email && atob(tokenA.idToken) == typeLogins.data.password) {
					commit('loginTokens', {email: tokenA.email, idToken: tokenA.idToken})
					localStorage.setItem('token', btoa(JSON.stringify({email: tokenA.email, idToken: tokenA.idToken})))
					commit('setLoading', false, {root: true})
				}
			}
		}
	}
}

export { login }